<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { TokenService } from '@/services/token.service.ts'
import ApiService from '@/services/api.service.ts'
import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app.store.ts'

const route = useRoute()
const router = useRouter()

const { setLogin } = useAppStore()

onMounted(() => {
  const token = route.query.token as string
  const tokenEmpty = token.trim() !== ''

  // token tidak boleh kosong
  if (tokenEmpty) {
    console.error('[Auth]: Token tidak valid!')
    router.push({ path: '/login' }) // fallback jika token invalid
  }

  // simpan token
  TokenService.saveToken(token)

  // atur header dan interceptor
  ApiService.setHeader()
  ApiService.mount401Interceptor()

  // set is login menjadi true
  setLogin(true)

  // arah kan ke home dan refresh halaman
  router.push({ name: 'home' }).then(() => {
    window.location.reload()
  })
})
</script>

<template>
  <p>Logging in with Google...</p>
</template>

<style scoped></style>
